import React from "react";
import "./About.css";

import img1sm from "../../assets/images/IMG_4464-sm.jpg";
import img1md from "../../assets/images/IMG_4464-md.jpg";
import img1lg from "../../assets/images/IMG_4464-lg.jpg";

import img2sm from "../../assets/images/IMG_4465-sm.jpg";
import img2md from "../../assets/images/IMG_4465-md.jpg";
import img2lg from "../../assets/images/IMG_4465-lg.jpg";

import img3sm from "../../assets/images/IMG_4466-sm.jpg";
import img3md from "../../assets/images/IMG_4466-md.jpg";
import img3lg from "../../assets/images/IMG_4466-lg.jpg";

import img4sm from "../../assets/images/IMG_4467-sm.jpg";
import img4md from "../../assets/images/IMG_4467-md.jpg";
import img4lg from "../../assets/images/IMG_4467-lg.jpg";

import { useLanguage } from "../../context/LanguageContext";

const About = () => {
  const { t } = useLanguage();

  return (
    <section className="about-section" id="about">

      {/* HEADING */}
      <div className="about-heading" data-aos="fade-right">
        <h1>{t.about.headingTitle}</h1>
        <p>{t.about.headingSubtitle}</p>
      </div>

      {/* BLOCK 1 */}
      <div className="about-container" data-aos="fade-left">
        <div className="about-images">
          <div className="image-card image-main">
            <img
              src={img1sm}
              srcSet={`${img1sm} 600w, ${img1md} 1200w, ${img1lg} 2000w`}
              sizes="(max-width: 900px) 90vw, 45vw"
              alt={t.about.block1.imageAltMain}
              loading="lazy"
            />
          </div>

          <div className="image-card image-floating">
            <img
              src={img2sm}
              srcSet={`${img2sm} 600w, ${img2md} 1200w, ${img2lg} 2000w`}
              sizes="(max-width: 900px) 80vw, 35vw"
              alt={t.about.block1.imageAltSecondary}
              loading="lazy"
            />
          </div>
        </div>

        <div className="about-text">
          <h2>{t.about.block1.title}</h2>
          <p>{t.about.block1.p1}</p>
          <p>{t.about.block1.p2}</p>
          <p>{t.about.block1.p3}</p>
        </div>
      </div>

      {/* BLOCK 2 */}
      <div className="about-container reverse">

        <div className="about-text">
          <h2>{t.about.block2.title}</h2>
          <p>{t.about.block2.p1}</p>
          <p>{t.about.block2.p2}</p>
          <p>{t.about.block2.p3}</p>
        </div>

        <div className="about-images" data-aos="fade-right">
          <div className="image-card image-main">
            <img
              src={img3sm}
              srcSet={`${img3sm} 600w, ${img3md} 1200w, ${img3lg} 2000w`}
              sizes="(max-width: 900px) 90vw, 45vw"
              alt={t.about.block2.imageAltMain}
              loading="lazy"
            />
          </div>

          <div className="image-card image-floating">
            <img
              src={img4sm}
              srcSet={`${img4sm} 600w, ${img4md} 1200w, ${img4lg} 2000w`}
              sizes="(max-width: 900px) 80vw, 35vw"
              alt={t.about.block2.imageAltSecondary}
              loading="lazy"
            />
          </div>
        </div>

      </div>

    </section>
  );
};

export default About;
